<template>
    <div class="modal-footer">
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "ModalFooter",
});
</script>

<style scoped>
.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    border-top: 1px solid var(--au-line);
    padding: 14px 0 0;
}

.modal-footer:empty {
    display: none;
}
</style>
